<template>
  <v-list-item
    :class="[
      itemClass,
      {'selected-item': isSelected}
    ]"
  >
    <v-list-item-avatar>
      <v-btn  icon @click="$emit('info-click', item)">
        <v-icon >mdi-information-outline</v-icon>
      </v-btn>
    </v-list-item-avatar>
    
    <v-list-item-content>
      <v-list-item-subtitle style="font-size: 12px;">
        {{ item.Product_ID }}
      </v-list-item-subtitle>
      <v-list-item-title 
        class="text-wrap" 
        :class="{'grey--text': isExhausted}"
        style="font-size: 14px;"
      >
      {{ item.ProductName }}
      </v-list-item-title>

    </v-list-item-content>
    
    <v-list-item-action class="d-flex flex-column align-center" style="min-width: 70px">
      <!-- Available product controls -->
      <div class="d-flex align-center" v-if="!isExhausted && !onlyShowSDAInv">
        <v-btn
          icon
          small
          @click="$emit('decrement', item)"
          :disabled="disabled || !selectedQuantity"
        >
          <v-icon small>mdi-minus</v-icon>
        </v-btn>
        
        <v-text-field
          :value="selectedQuantity"
          @input="$emit('quantity-change', item, $event)"
          type="number"
          min="0"
          :max="item.AvailPosot"
          style="width: 25px; font-size: 14px;"
          class="mx-1"
          hide-details
          dense
          :rules="[v => v <= item.AvailPosot || 'Too many']"
          :disabled="disabled"
        />
        
        <v-btn
          icon
          small
          @click="$emit('increment', item)"
          :disabled="disabled || selectedQuantity >= item.AvailPosot"
        >
          <v-icon small>mdi-plus</v-icon>
        </v-btn>
      </div>
      
      <!-- Exhausted product indicator -->
      <div class="d-flex align-center" v-else-if="isExhausted">
        <v-chip small color="grey" text-color="white">
          Εξαντλημένο
        </v-chip>
      </div>
      
      <!-- Progress bar -->
      <div class="mt-1" style="width: 100%">
        <v-progress-linear
          :value="progressValue"
          height="10"
          rounded
          :color="progressColor"
        >
          <template v-slot:default="{ value }">
            <span class="white--text" style="font-size: 10px;">
              {{ availableAmount }}/{{ item.StartPosot }}
            </span>
          </template>
          <template v-slot:background>
            <div style="background-color: rgba(0,0,0,0.15); height: 100%; width: 100%;"></div>
          </template>
        </v-progress-linear>
      </div>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  name: 'SDAProductItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    selectedQuantity: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    onlyShowSDAInv: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isExhausted() {
      return this.item.AvailPosot === 0
    },
    isSelected() {
      return this.selectedQuantity > 0
    },
    availableAmount() {
      return this.item.AvailPosot - (this.selectedQuantity || 0)
    },
    progressValue() {
      if (this.isExhausted) return 0
      return (this.availableAmount / this.item.StartPosot) * 100
    },
    progressColor() {
      if (this.isExhausted) return 'grey'
      const percentage = this.progressValue
      if (percentage <= 20) return '#FF525288'
      if (percentage <= 70) return '#dfcd0088'
      return '#4CAF5088'
    },
    itemClass() {
      if (this.isExhausted) return 'border-left-grey'
      const percentage = this.progressValue
      if (percentage <= 20) return 'border-left-error'
      if (percentage <= 70) return 'border-left-warning'
      return 'border-left-success'
    }
  }
}
</script>

<style scoped>
.border-left-success {
  border-left: 2px solid #4CAF50 !important;
}
.border-left-warning {
  border-left: 2px solid #FFC107 !important;
}
.border-left-error {
  border-left: 2px solid #FF5252 !important;
}
.border-left-grey {
  border-left: 2px solid #9E9E9E !important;
}
.selected-item {
  background-color: rgba(0,73,200,0.13);
}
</style> 